

// to avoid infinit loop of fetching texts.
export const RETRIEVE_MESSAGES_LIMIT = 4
